export default __webpack_public_path__ + "static/media/close-circle-filled.4ed994ed.svg";